import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Link, Button, Grid, Paper } from "@material-ui/core";
import amplitudeLogger from "../../utils/amplitude";
import { WAND_DASHBOARD_PAGE } from "../../utils/amplitude";
import { masterMetricDetails } from "../analytics/analyticsConstants";
import WandUsageDataHandler from "../../utils/analytics/WandUsageDataHandler";
import { getRequest } from "../../utils/httpHelpers";
import AnalyticsChart from "../analytics/metrics/v2/AnalyticsChart";
import CircularProgress from "@material-ui/core/CircularProgress";
import { getStaticResourceUrl } from "../../utils/urlHelpers";
import { UserInfoContext } from "../../contexts/UserInfoContext";
import VideocamIcon from "@material-ui/icons/Videocam";
import TodayIcon from "@material-ui/icons/Today";
/* global Calendly */

const useStyles = makeStyles((theme) => ({
  title: {
    marginBottom: theme.spacing(4),
  },
  youtubeDemo: {
    borderRadius: "16px",
    aspectRatio: "16 / 9",
    // width: "680px",
  },
  actionButtonContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      gap: theme.spacing(2),
    },
  },
  lastWeekCount: {
    fontSize: "16px",
    marginLeft: theme.spacing(0.5),
    marginBottom: "6px",
    fontWeight: "bold",
  },
  root: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    paddingLeft: theme.spacing(5),
  },
  gridContainer: {
    padding: theme.spacing(3),
    height: "80vh",
  },
  rightGridContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    justifyContent: "space-between",
    alignItems: "center",
  },
  jobBoardGridItem: {
    marginTop: "8px",
    marginBottom: "8px",
  },
  dashboardPaperCard: {
    padding: theme.spacing(3),
    paddingTop: "20px",
    borderRadius: "16px",
    boxShadow: "0 2px 12px rgba(0,0,0,0.05)",
    backgroundColor: "#fff",
    // minHeight: "150px",
    height: "100%",
    width: "100%",
    display: "flex",
    textAlign: "center",
    flexDirection: "column",
    justifyContent: "space-evenly",
  },
  gridItem: {
    width: "100%",
  },
}));

export default function WandDashboard() {
  const classes = useStyles();
  const [wandUsageData, setWandUsageData] = React.useState(null);
  const [totalDownloads, setTotalDownloads] = React.useState(0);
  const [lastWeekCount, setLastWeekCount] = React.useState(0);
  const [isDashboardLoading, setIsDashboardLoading] = React.useState(true);
  const [userInfo] = React.useContext(UserInfoContext);
  let analyticsObject = new WandUsageDataHandler("", "");

  React.useEffect(() => {
    document.title = "Wand Dashboard | Reczee";
    amplitudeLogger.logEvent("WAND_DASHBOARD_LOADED");

    setIsDashboardLoading(true);
    getRequest(
      "analytics/fetch-wand-usage-graph-data",
      {},
      (response) => {
        setWandUsageData(response["wand_usage_data"]);
        setTotalDownloads(response["total_downloads"]);
        setLastWeekCount(response["last_week_count"]);
        setIsDashboardLoading(false);
      },
      (errorMessages) => {
        setIsDashboardLoading(false);
      }
    );
  }, []);

  React.useEffect(() => {
    const head = document.querySelector("head");
    const script = document.createElement("script");
    script.setAttribute(
      "src",
      "https://assets.calendly.com/assets/external/widget.js"
    );
    const link = document.createElement("link");
    link.setAttribute(
      "href",
      "https://assets.calendly.com/assets/external/widget.css"
    );
    link.setAttribute("rel", "stylesheet");
    head.appendChild(script);
    head.appendChild(link);
  }, []);

  return (
    <>
      {isDashboardLoading ? (
        <CircularProgress />
      ) : (
        <>
          <Grid container spacing={3} className={classes.gridContainer}>
            {/* Main Visual Panel */}
            <Grid item xs={12} md={8}>
              <Paper className={classes.dashboardPaperCard}>
                {wandUsageData ? (
                  <AnalyticsChart
                    selectedMetric={"wand_usage"}
                    backendData={wandUsageData}
                    analyticsObject={analyticsObject}
                    amplitudePage={WAND_DASHBOARD_PAGE}
                    visibleAttributes={[]}
                    chartSlug={""}
                    title={
                      wandUsageData && wandUsageData.sample ? (
                        <div>
                          <div>
                            Applicant Downloads with Wand
                            <Link
                              style={{
                                cursor: "pointer",
                                marginLeft: "4px",
                                fontSize: "10px",
                              }}
                              onClick={() => {
                                amplitudeLogger.logEvent(
                                  "WAND_DASHBOARD_HOW_IT_WORKS_CLICKED"
                                );
                              }}
                              href="https://youtu.be/wzSfacUiMVw"
                              target="_blank"
                            >
                              How it works?
                            </Link>
                          </div>
                          <div
                            style={{
                              fontSize: "12px",
                              color: "#8600d9",
                              textAlign: "left",
                            }}
                          >
                            (Sample data)
                          </div>
                        </div>
                      ) : (
                        <div>
                          Applicant Downloads with Wand
                          <Link
                            style={{
                              cursor: "pointer",
                              marginLeft: "4px",
                              fontSize: "10px",
                            }}
                            onClick={() => {
                              amplitudeLogger.logEvent(
                                "WAND_DASHBOARD_HOW_IT_WORKS_CLICKED"
                              );
                            }}
                            href="https://youtu.be/wzSfacUiMVw"
                            target="_blank"
                          >
                            How it works?
                          </Link>
                        </div>
                      )
                    }
                  />
                ) : (
                  ""
                )}
              </Paper>
            </Grid>

            {/* Side Cards */}
            <Grid item xs={12} md={4} className={classes.rightGridContainer}>
              <Paper className={classes.dashboardPaperCard} style={{}}>
                <Typography variant="h6" gutterBottom>
                  Total Downloads
                </Typography>
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-end",
                    justifyContent: "center",
                  }}
                >
                  <Typography variant="h3">{totalDownloads}</Typography>
                  <span
                    className={classes.lastWeekCount}
                    style={{ color: lastWeekCount > 0 ? "green" : "grey" }}
                  >
                    +{lastWeekCount} in this week
                  </span>
                </div>
              </Paper>
              <Paper className={classes.dashboardPaperCard}>
                <Typography variant="h6" gutterBottom>
                  Supported Job Boards
                </Typography>
                <Grid container style={{ alignItems: "center" }}>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    className={classes.jobBoardGridItem}
                  >
                    <img
                      src={getStaticResourceUrl("/job-boards/linkedin.svg")}
                      alt="LinkedIn"
                      style={{ width: "auto", height: "26px" }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    className={classes.jobBoardGridItem}
                  >
                    <img
                      src={getStaticResourceUrl("/job-boards/hirist.svg")}
                      alt="hirist.tech"
                      style={{ width: "auto", height: "26px" }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    className={classes.jobBoardGridItem}
                  >
                    <img
                      src={getStaticResourceUrl("/job-boards/iimjobs.svg")}
                      alt="iimjobs.com"
                      style={{ width: "auto", height: "28px" }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    className={classes.jobBoardGridItem}
                  >
                    <img
                      src={getStaticResourceUrl("/job-boards/updazz.svg")}
                      alt="updazz.com"
                      style={{ width: "auto", height: "28px" }}
                    />
                  </Grid>
                </Grid>
                <Typography variant="subtitle" style={{ marginTop: "10px" }}>
                  <Link
                    href="https://forms.gle/Qcrfhp9jcYcs8AST7"
                    target="_blank"
                  >
                    Request new job board?
                  </Link>
                </Typography>
              </Paper>

              <Paper className={classes.dashboardPaperCard}>
                <Link href="https://reczee.com/ats" target="_blank">
                  <img
                    height="36"
                    alt="Reczee ATS"
                    style={{ marginLeft: "8px", marginRight: "8px" }}
                    src={getStaticResourceUrl("/reczee-ats-dark-logo.svg")}
                  />
                </Link>
                <div
                  style={{
                    fontSize: "16px",
                    fontWeight: "bold",
                    color: "grey",
                    marginBottom: "16px",
                  }}
                >
                  The World's First Agentic ATS ✨
                </div>
                {/* <div>
                  Future of recruiting is here! Tactical recruitment{" "}
                  <b>actions</b> with simple prompts.
                </div> */}
                <div className={classes.actionButtonContainer}>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      window.open(
                        "https://www.youtube.com/watch?v=dfg-Zak6RIg&pp=ygUGcmVjemVl",
                        "_blank"
                      );
                    }}
                    startIcon={<VideocamIcon fontSize="small" />}
                  >
                    Watch Demo
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      if (Calendly) {
                        Calendly.initPopupWidget({
                          url: `https://calendly.com/raj-reczee/45?hide_event_type_details=1&email=${
                            userInfo.email
                          }&name=${encodeURIComponent(userInfo.name)}`,
                        });
                        return false;
                      }
                    }}
                    startIcon={<TodayIcon fontSize="small" />}
                  >
                    Schedule demo
                  </Button>
                </div>
              </Paper>
            </Grid>
          </Grid>
          {/* <Grid container>
            <Grid item xs={12} md={6}>
              <Paper
                className={classes.dashboardPaperCard}
                style={{ alignItems: "center" }}
              >
                <iframe
                  width="560"
                  height="315"
                  className={classes.youtubeDemo}
                  src="https://www.youtube.com/embed/wzSfacUiMVw?si=wO5_xbuUBgw2Rs_N"
                  title="Reczee Wand Demo"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                ></iframe>
              </Paper>
            </Grid>

            <Grid item xs={12} md={6}>
              <Paper className={classes.dashboardPaperCard}>
                <Typography variant="h6" gutterBottom>
                  Experience the world's first Agentic ATS
                </Typography>
                <Typography variant="body2">
                  Our advanced AI seamlessly guides candidates through your
                  hiring pipeline. Stay ahead with intelligent automation.
                </Typography>
              </Paper>
            </Grid>
          </Grid> */}
        </>
      )}
    </>
  );
}
